import {GridComponent, ColumnsDirective, ColumnDirective, Resize, Sort, ContextMenu, Filter, Page, ExcelExport, PdfExport, Edit, Inject, Toolbar} from '@syncfusion/ej2-react-grids'
import {ordersData, ordersGrid} from '../data/dummy'
import {Header} from '../components'

const Orders = () => {
  const toolbar =  ['PdfExport', 'ExcelExport'];
  return (
    <div className='m-2 md:m-10 p-2 md:10 bg-white rounded-3xl drop-shadow-sm'>
      <Header title='Orders' category='Page'/>
      <GridComponent
        id='gridcomp'
        dataSource={ordersData}
        allowPaging
        allowSorting
        allowExcelExport
        allowPdfExport
        toolbar={toolbar}
      >
        <ColumnsDirective>
          {ordersGrid.map((item, index)=> <ColumnDirective key={index} {...item} />)}
        </ColumnsDirective>
        <Inject services={[Resize, Sort, ContextMenu, Filter, Page, ExcelExport, Edit, PdfExport, Toolbar]}/>
      </GridComponent>
    </div>
  )
}

export default Orders
